import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'device_id',
        title: 'Cihaz Seri No',
        rules: {required: true},
        modal: ['device_id'],
        data: ['device_id'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'name',
        title: 'İsim',
        rules: {required: true},
        modal: ['device_name'],
        data: ['device_name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'devicetype',
        title: 'Cihaz Tipi',
        rules: {required: true},
        options: {
            data: [],
            label: 'description',
            track: 'id'
        },
        modal: ['device_type_id'],
        data: ['DeviceType',],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/devices.js